<template>
  <!-- class="lg:flex flex-1" -->
  <Nav />
  <toTopComponent />
  <router-view />
  <Footer />
</template>

<script>
import Nav from "@/components/new/Nav.vue";
import toTopComponent from "@/components/toTopComponent.vue";
import Footer from "@/components/new/Footer.vue";

export default {
  name: "mainView",
  components: { Nav, toTopComponent, Footer },
};
</script>
